import React from 'react';
import { Link } from 'react-router';

const Comp = (props) => {
  const { letter, alpha, idSeason } = props
  return <Link className={`btn btn-${letter === alpha ? 'info' : 'link'} btn-sm`} 
  to={`/season/${idSeason}/shirts/${alpha}`}>{alpha}</Link>
}

export default Comp;